import Vue from 'vue';
import VueRouter from 'vue-router';
import iview from 'iviewxx';
import Vuex from 'vuex';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import zhLocale from '@/components/locale/lang/zh-CN';
import enLocale from '@/components/locale/lang/en-US';
import twLocale from '@/components/locale/lang/zh-TW';
import store from '@/store/store';
import '@/assets/http'; // 引入拦截器
import '@/assets/common';
import echarts from 'echarts';

// 路由配置，定义路由
import main from '@/components/layout/main';
import register from './components/register';
// 注册
import findpassword from './components/findpassword';
// 找回密码
import findpasswordForEmail from './components/findpasswordForEmail';
Vue.prototype.$echarts = echarts;// 邮箱找回密码

Vue.prototype.axios = axios;
Vue.config.debug = true; // 开启debug模式
Vue.use(VueRouter); // 初始化自定义组件
Vue.use(VueI18n);
Vue.use(iview);
Vue.use(Vuex);
Vue.locale('zh-CN', zhLocale);
Vue.locale('en-US', enLocale);
Vue.locale('zh-TW', twLocale);
let lang = localStorage.getItem('lang');
if (lang != null) {
  Vue.config.lang = lang;
} else {
  const language = navigator.browserLanguage ? navigator.browserLanguage : navigator.language;
  Vue.config.lang = language;
  localStorage.setItem('lang', language);
}
// 引入路由组件
store.commit('inGroup', 'index'); // 需AJAX向server请求菜单
let pageName = getLastPageName();
store.commit('thisPage', pageName);
const routes = [{
  path: '/',
  component: main,
  redirect: '/register', // 引入主文件
  children: [{
    path: '/register',
    component: register
  },
  {
    path: '/findpassword',
    component: findpassword // 渠道管理
  },
  {
    path: '/findpasswordForEmail',
    component: findpasswordForEmail // 渠道管理
  }
  ]
}];
const router = new VueRouter({
  mode: 'hash',
  history: false,
  routes
});

function getLastPageName () {
  let url = window.location.href;
  let l;
  if (url.indexOf('?') > 0) {
    url = url.split('?')[0].split('/');
    l = url.length;
  } else {
    url = url.split('/');
    l = url.length;
  }
  return url[l - 1];
}

// 创建实例挂载到#app
new Vue({
  router,
  store // 引入store配置
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/views/index/index.js